// extracted by mini-css-extract-plugin
export var container = "AboutSection-module--container--9ASwo";
export var content = "AboutSection-module--content--rxn2H";
export var image = "AboutSection-module--image--h5H1v";
export var overlay = "AboutSection-module--overlay--YH+O1";